class ImTokensGetter {

  constructor(access_token) {
    this.access_token = access_token
  }

  async get(site_name) {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/configurations/tokens/${site_name}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.access_token
        }
      }
    );

    if (!response.ok) return null;

    return await response.json();
  }
}

export default ImTokensGetter;
